import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import css from './style.module.scss'

import iconBigWarningSVG from '../../assets/img/icon-big-warning.svg'
import iconEmailSVG from '../../assets/img/icon-email.svg'
import iconFaxSVG from '../../assets/img/icon-fax.svg'
import iconCloseSVG from '../../assets/img/icon-close.svg'
import iconUploadSVG from '../../assets/img/icon-upload.svg'
import iconSucessSVG from '../../assets/img/icon-sucess.svg'
import iconAttachedDocument from '../../assets/img/icon-attached-document.svg'

export default class Icon extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string
  }

  render () {
    const { name, className, ...props } = this.props
    const icons = {
    'big-warning': iconBigWarningSVG,
    'email': iconEmailSVG,
    'fax': iconFaxSVG,
    'close': iconCloseSVG,
    'upload': iconUploadSVG,
    'attached-document': iconAttachedDocument,
    'success': iconSucessSVG
    }
    const icon = icons[name] || ''

    return (
      <div className={classNames(className, css.icon)}>
        <img
          alt={'icon-' + name}
          src={icon}
          {...props}
        />
      </div>
    )
  }
}
